import React, { useEffect, useState } from "react";
import CertificationBodyReviewStep1 from "../../certificationBody/review/flow/certificationBodyReviewStep1";
import { setStakeholderApplicationNumber } from "../../../app/api/NOCU/helpers/applicationApiHelpers";
import { SectionRow } from "../../../layouts/sections";
import { Button, Stack } from "@mui/material";
import { getStepStatusByApplicationId } from "../../../app/api/NOCU/applicationAPI";
import TopButtonArray from "./components/TopButtonArray";
import CertificationBodyReviewStep2 from "../../certificationBody/review/flow/certificationBodyReviewStep2";
import CertificationBodyReviewStep3 from "../../certificationBody/review/flow/certificationBodyReviewStep3";
import CertificationBodyReviewStep4 from "../../certificationBody/review/flow/certificationBodyReviewStep4";
import CertificationBodyReviewStep5 from "../../certificationBody/review/flow/certificationBodyReviewStep5";
import LabReviewStep1 from "./../../labs/review/flow/LabStep1";
import LabReviewStep2 from "./../../labs/review/flow/LabStep2";
import LabReviewStep3 from "./../../labs/review/flow/LabStep3";
import LabReviewStep4 from "./../../labs/review/flow/LabStep4";
import LabReviewStep5 from "./../../labs/review/flow/LabStep5";
import ExporterStep1 from "./../../exporter/review/flow/ExporterStep1";
import ExporterStep2 from "./../../exporter/review/flow/ExporterStep2";
import ExporterStep3 from "./../../exporter/review/flow/ExporterStep3";
import ExporterStep4 from "./../../exporter/review/flow/ExporterStep4";
import ExporterStep5 from "./../../exporter/review/flow/ExporterStep5";
import ExporterStep6 from "./../../exporter/review/flow/ExporterStep6";
import ExporterStep7 from "./../../exporter/review/flow/ExporterStep7";
import ExporterStep8 from "./../../exporter/review/flow/ExporterStep8";
import ProcessorStep1 from "./../../processor/review/flow/ProcessorStep1";
import ProcessorStep7 from "./../../processor/review/flow/ProcessorStep7";
import ProcessorStep6 from "./../../processor/review/flow/ProcessorStep6";
import ProcessorStep5 from "./../../processor/review/flow/ProcessorStep5";
import ProcessorStep4 from "./../../processor/review/flow/ProcessorStep4";
import ProcessorStep3 from "./../../processor/review/flow/ProcessorStep3";
import ProcessorStep2 from "./../../processor/review/flow/ProcessorStep2";
import LoaderComponent from "../../../components/Loader/LoaderComponent";

const ProcessorSummaryView = ({ applicationId }) => {
	const [selectedPage, setSelectedPage] = useState(0);
	const [statusArray, setStatusArray] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setStakeholderApplicationNumber(applicationId);
		getStepStatusByApplicationId(applicationId)
			.then((res) => {
				setStatusArray([
					res.data[0],
					res.data[1],
					res.data[2],
					res.data[5],
					res.data[7],
					res.data[3],
					res.data[4],
				]);
			})
			.finally(() => {
				setTimeout(() => setLoading(false), 1000);
			});
	}, [applicationId]);

	const btnNames = [
		"Business Details",
		"Contact Personnel",
		"Management Details",
		"Source of Products",
		"Current Product Details",
		"Certificates",
		"Other Documents",
	];

	return (
		<div>
			<SectionRow className='w-full justify-center'>
				{statusArray && (
					<TopButtonArray
						nameArray={btnNames}
						selectedPage={selectedPage}
						setSelectedPage={setSelectedPage}
						statusArray={statusArray}
					/>
				)}
			</SectionRow>
			{!loading && selectedPage === 0 ? (
				<ProcessorStep1
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 1 ? (
				<ProcessorStep2
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 2 ? (
				<ProcessorStep3
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 3 ? (
				<ProcessorStep4
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 4 ? (
				<ProcessorStep5
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 5 ? (
				<ProcessorStep6
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : selectedPage === 6 ? (
				<ProcessorStep7
					hideBtns={true}
					stepperData={undefined}
					stepperName={undefined}
					routeArray={undefined}
					setIsLoading={setLoading}
					readOnly={true}
				/>
			) : (
				<></>
			)}
			<LoaderComponent isOpen={loading} />
		</div>
	);
};

export default ProcessorSummaryView;
